import { z } from "zod";
import { MAILBOX_PURPOSES } from "../mailbox.schema";

/** The list is always asked for one purpose: the tab that shows it belongs to that feature. */
export const getMailboxesQuerySchema = z.object({
	purpose: z.enum(MAILBOX_PURPOSES),
});

export type GetMailboxesQuerySchema = z.infer<typeof getMailboxesQuerySchema>;
